import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e0a7edd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-comment border-bottom mb-4 pb-2"
}
const _hoisted_2 = ["data-bs-target"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "img__mb me-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "d-flex align-items-center fs-7 fw-bold" }
const _hoisted_8 = { class: "fs-8 date-text" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "img__mb me-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "d-flex align-items-center fs-7 fw-bold" }
const _hoisted_14 = { class: "fs-8 date-text" }
const _hoisted_15 = ["onClick"]

import Avatar from '@/components/avatar/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import SubmenuComment from '@/components/submenu/comment.vue'
import { UserType } from '@/store/modules/post'
import { PropType, ref, computed } from 'vue-demi'
import { ChangeTime } from '@/constants/datepicker'
import TargetTag from '@/components/target-tag/index.vue'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'
import { Modal } from 'bootstrap'
import { ACCOUNT_STORE, POST_STORE, COMMUNITY_SITE_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { numberWithCommas } from '@/constants/common.ts'
import { watch, nextTick } from 'vue'
import { Collapse } from 'bootstrap'

export type CommentType = {
  id: string
  post_id: string
  comment: string
  my_comment: boolean
  created_at: string
  display_name: string
  image_url: string
  user_type: UserType
}


export default /*#__PURE__*/_defineComponent({
  props: {
  comments: {
    type: Array as PropType<Array<CommentType>>,
    default: () => [],
  },
  postId: {
    type: Number,
  },
  comment_count: {
    type: Number,
  },
  isCSPDetail: {
    type: Boolean,
  },
  mention_users: {
    type: Object,
  },
  isNotLoadingPostSkeleton: {
    type: Boolean,
    default: false,
  },
  isCSP: {
    type: Boolean,
    default: false,
  },
  isCSPDeleted: {
    type: Boolean,
    default: false,
  },
  id_comment: {
    type: String,
    default: null,
  },
},
  emits: ['setCommentData'],
  setup(__props, { emit }) {

const props = __props

const route = useRoute()
const store = useStore()


const modal = ref()

const showAllComments = ref<boolean>(false)
const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)

const getComments = async () => {
  const payload = {
    community_id: route?.params?.id,
    params: {
      post_id: props?.postId,
      create_by_admin: false,
      isNotLoadingPostSkeleton: props?.isNotLoadingPostSkeleton,
      from_sf_10: props?.isCSP,
    },
  }
  if (props?.isCSPDetail) {
    await store.dispatch(COMMUNITY_SITE_STORE.ACTIONS.SET_LIST_COMMENT_CSP, payload)
  } else {
    await store.dispatch(POST_STORE.ACTIONS.SET_LIST_COMMENT, payload)
  }
}
const scrollToMessage = () => {
  const interval = setInterval(() => {
    const header = document.getElementsByTagName('header')
    const headerHeight = header.length ? header[0].offsetHeight : 70
    const element = document.getElementById(props.id_comment) as HTMLElement | null
    if (element) {
      clearInterval(interval)
      stopScroll.value = true
      const elementPosition = element.getBoundingClientRect().top - headerHeight - 20
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      })
    }
  }, 200)
  setTimeout(() => {
    clearInterval(interval)
  }, 5000)
}

watch(
  () => props.id_comment,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        const isCommentIdLast = props.comments.slice(-1)[0]?.id == newVal
        const collapseElement = document.getElementById(`flush-collapse${props.postId}`)
        if (collapseElement && !isCommentIdLast) {
          const bsCollapse = new Collapse(collapseElement, { toggle: false })
          showAllComments.value = true
          bsCollapse.show()
        } else {
          scrollToMessage()
        }
      })
    }
  },
  {
    immediate: true,
  }
)

const stopScroll = ref(false)
watch(
  () => showAllComments.value,
  async () => {
    if (showAllComments.value) {
      await getComments()
      if (props.id_comment && !stopScroll.value) {
        const isCommentIdLast = props.comments.slice(-1)[0]?.id == props.id_comment
        if (!isCommentIdLast) {
          scrollToMessage()
        }
      }
    }
  }
)



const setCommentData = (post_id, id, published) => {
  emit('setCommentData', post_id, id, published)
}

const handleShowUser = async (id, userID, userType, myComment, is_deleted_in_30_days, is_puplic_profile) => {
  if (userType === 'community_admin' || myComment || is_deleted_in_30_days === 2 || !is_puplic_profile) {
    return
  }
  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType })
  if (showModal.value) {
    await modal.value?.show()
  }
}

return (_ctx: any,_cache: any) => {
  return (__props.comment_count > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.comment_count > 1)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "text-decoration-underline fs-75 cursor-pointer mb-4",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#flush-collapse${__props.postId}`,
              "aria-expanded": "false",
              "aria-controls": "flush-collapseOne",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAllComments.value = !showAllComments.value))
            }, [
              _createTextVNode("他" + _toDisplayString(_unref(numberWithCommas)(__props.comment_count - 1)) + "件のコメントを見る ", 1),
              _createElementVNode("i", {
                class: _normalizeClass(["fas fa-caret-down", [!showAllComments.value ? '' : 'rotate']])
              }, null, 2)
            ], 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: `flush-collapse${__props.postId}`,
          class: "accordion-collapse collapse",
          "aria-labelledby": "flush-headingOne",
          "data-bs-parent": "#accordionFlushExample"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments.slice(0, -1), (comment) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "user mb-3 d-flex",
              key: comment.id,
              id: comment.id
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(Avatar, {
                  is_deleted_in_30_days: comment?.is_deleted_in_30_days,
                  user_image_url: comment?.image_url,
                  size: 'small',
                  userType: comment.user_type
                }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["flex-grow-1", { 'message-highlight': comment.id === __props.id_comment }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([comment.user_type === 'community_admin' || comment?.my_comment || comment?.is_deleted_in_30_days === 2 || !comment?.is_profile_public ? '' : 'cursor-pointer']),
                  onClick: 
              () => handleShowUser(_unref(route).params?.id, comment.management_no, comment.user_type, comment?.my_comment, comment?.is_deleted_in_30_days, comment?.is_profile_public)
            
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(UserAliasIcon, {
                      userType: comment.user_type
                    }, null, 8, ["userType"]),
                    _createElementVNode("span", null, _toDisplayString(comment?.display_name), 1)
                  ]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(ChangeTime)(comment?.created_at)), 1)
                ], 10, _hoisted_6),
                _createVNode(TargetTag, {
                  data: comment?.comment,
                  class: "mb-0 fs-7",
                  users: __props.mention_users
                }, null, 8, ["data", "users"])
              ], 2),
              _createElementVNode("div", {
                onClick: ($event: any) => (setCommentData(comment.post_id, comment.id, comment.published))
              }, [
                (comment.my_comment)
                  ? (_openBlock(), _createBlock(SubmenuComment, {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (getComments())),
                      dataBs: [['modal', '#deleteComment']],
                      class: _normalizeClass(__props.isCSPDeleted ? 'disabled' : '')
                    }, null, 8, ["class"]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_9)
            ], 8, _hoisted_4))
          }), 128))
        ], 8, _hoisted_3),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments.slice(-1), (comment) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "user mb-3 d-flex",
            key: comment.id,
            id: comment.id
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(Avatar, {
                is_deleted_in_30_days: comment?.is_deleted_in_30_days,
                user_image_url: comment?.image_url,
                size: 'small',
                userType: comment.user_type
              }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["flex-grow-1", { 'message-highlight': comment.id === __props.id_comment }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([comment.user_type === 'community_admin' || comment?.my_comment || comment?.is_deleted_in_30_days === 2 || !comment?.is_profile_public ? '' : 'cursor-pointer']),
                onClick: () => handleShowUser(_unref(route).params?.id, comment.management_no, comment.user_type, comment?.my_comment, comment?.is_deleted_in_30_days, comment?.is_profile_public)
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(UserAliasIcon, {
                    userType: comment.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("span", null, _toDisplayString(comment?.display_name), 1)
                ]),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(ChangeTime)(comment?.created_at)), 1)
              ], 10, _hoisted_12),
              _createVNode(TargetTag, {
                data: comment?.comment,
                class: _normalizeClass('mb-0 fs-7'),
                users: __props.mention_users
              }, null, 8, ["data", "users"])
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments.slice(-1), (comment) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex",
                key: comment.id,
                onClick: ($event: any) => (setCommentData(comment.post_id, comment.id, comment.published))
              }, [
                (comment.my_comment)
                  ? (_openBlock(), _createBlock(SubmenuComment, {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (getComments())),
                      dataBs: [['modal', '#deleteComment']],
                      class: _normalizeClass(__props.isCSPDeleted ? 'disabled' : '')
                    }, null, 8, ["class"]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_15))
            }), 128))
          ], 8, _hoisted_10))
        }), 128)),
        _createVNode(PortfolioAlumni),
        _createVNode(PortfolioUser)
      ]))
    : _createCommentVNode("", true)
}
}

})